module.exports = __webpack_public_path__ + "static/media/miysis_3d_cdcl_dpp_int-res2_app1.12_sdb-v2_final03.20109c04.jpg";